module.exports = __webpack_public_path__ + "img/resources-1920.053ec0b1.jpg";